import { gql } from '@apollo/client'
import { useBoxModal } from '@jusbrasil-web/shared-box-lock'
import {
  CopyContentTriggerStandalone,
  CopyContentTriggerStandaloneProps,
} from '@jusbrasil-web/shared-feature-locker'

export type CopyContentTriggerStandaloneFarolProps = Omit<
  CopyContentTriggerStandaloneProps,
  'boxModalComponent' | 'onVisibleChange'
> & {
  fromComponent?: string
}

export function CopyContentTriggerStandaloneFarol(props: CopyContentTriggerStandaloneFarolProps) {
  const { appId, featureCode, product = null, viewer, fromComponent = 'DocumentSnippet' } = props

  const boxLockProps = {
    appId,
    featureCode,
    fromComponent,
    boxOptions: {},
    product,
    pageMetadata: {},
  }
  const { setOpen } = useBoxModal({ ...boxLockProps, viewer })

  return <CopyContentTriggerStandalone {...props} onVisibleChange={setOpen} />
}

CopyContentTriggerStandaloneFarol.fragments = {
  document: gql`
    fragment CopyContentTriggerStandaloneFarol_document on Document {
      ...CopyContentTriggerStandalone_document
    }
    ${CopyContentTriggerStandalone.fragments.document}
  `,

  haystackItem: gql`
    fragment CopyContentTriggerStandaloneFarol_haystackItem on HaystackItem {
      ...CopyContentTriggerStandalone_haystackItem
    }
    ${CopyContentTriggerStandalone.fragments.haystackItem}
  `,

  viewer: gql`
    fragment CopyContentTriggerStandaloneFarol_viewer on Profile {
      ...CopyContentTriggerStandalone_viewer
      ...useBoxModal_viewer
    }
    ${CopyContentTriggerStandalone.fragments.viewer}
    ${useBoxModal.fragments.viewer}
  `,
}
